import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import HoveredButton from 'emergency_data/src/components/HoveredButton';
import {
  AddressBox,
  HomeStreet,
  CityRegion,
  TextWrapper,
  FadedTextWrapper,
  AddressContainer,
  AddressContainerWithCopy,
} from 'emergency_data/src/components/Location/styles/locationAddress.styles';
import { CENTRAL_STATION } from '@rsos/constants/appNames.js';
import copyToClipboard from '@rsos/utils/copyToClipboard';
import { NoAddress } from './NoAddress';
import { trackCopyAlertAddress } from './alertLocationTrackings';

const LocationAddress = ({
  isHistoricLocation,
  isCompact,
  isHoverable,
  civic,
}) => {
  const [isCopied, setIsCopied] = useState();
  const selectedAlertID = useSelector(state => state.incidents.selectedAlertID);
  const irpVersion = useSelector(state => state.sinatra.irp.irpVersion);
  const { application } = useSelector(state => state.sinatra.user.currentRole);
  const isCentralStation = application === CENTRAL_STATION;

  const { street_1, street_2, city, state, zip_code } = civic;
  const noAddress = !street_1 && !street_2 && !city && !state;
  const TopAddress =
    street_1 && street_1 !== ' ' && street_2 ? (
      <TextWrapper dataLocation>{`${street_1} ${street_2}\u00A0`}</TextWrapper>
    ) : street_1 && street_1 !== ' ' && !street_2 ? (
      <TextWrapper dataLocation>{`${street_1}\u00A0`}</TextWrapper>
    ) : street_2 && !street_1 ? (
      <>
        <FadedTextWrapper dataLocation inline>
          (Bldg# N/A)
        </FadedTextWrapper>
        {`${street_2}\u00A0`}
      </>
    ) : (
      <FadedTextWrapper
        dataLocation
      >{`Street not available\u00A0`}</FadedTextWrapper>
    );

  const onClick = () => {
    setIsCopied(true);
    copyToClipboard(
      `${street_1 !== ' ' && !street_2 ? `${street_1},` : ''}${
        street_1 !== ' ' && street_2 ? `\u00A0${street_2},` : ''
      } ${city ? `${city},\u00A0` : ''}${state ? state : ''} ${
        zip_code ? zip_code : ''
      }`.trim(),
    );
    trackCopyAlertAddress(selectedAlertID, irpVersion);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };
  return (
    <AddressBox {...{ isCompact }} data-name="location-address" width="100%">
      {noAddress ? (
        <NoAddress />
      ) : (
        <AddressContainerWithCopy
          br={'5px'}
          isHoverable={isHoverable}
          copied={isCopied}
          align={'flex-start'}
        >
          <AddressContainer
            pr={2}
            br="5px"
            ellipsis
            flexWrap="wrap"
            minHeight="25px"
            align="flex-start"
            isHistoricLocation={isHistoricLocation}
            isCentralStation={isCentralStation}
          >
            <HomeStreet ellipsis dataLocation isHoverable={isHoverable}>
              {TopAddress}
            </HomeStreet>
            <CityRegion dataLocation>
              {city}, {state} {zip_code}
            </CityRegion>
          </AddressContainer>
          {isHoverable && !noAddress && (
            <HoveredButton
              onClick={onClick}
              isCopied={isCopied}
              withIcon
              absolute
            />
          )}
        </AddressContainerWithCopy>
      )}
    </AddressBox>
  );
};

export default LocationAddress;
